<template>
  <div id="label-type">
    <div ref="echarts" class="chart-box"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  props: {
    showMore: {
      type: Boolean
    },
    labelName: {
      type: Array,
      default () {
        return []
      }
    },
    labelCount: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      chartBar: null
    }
  },
  activated () {
    // 由于给echart添加了resize事件, 在组件激活时需要重新resize绘画一次, 否则出现空白bug
    if (this.chartBar) {
      this.chartBar.resize()
    }
  },
  watch: {
    labelCount: {
      // immediate: true,
      handler (val) {
        if (val.length !== 0) {
          this.initChartBar()
        } else {
          this.chartBar = echarts.init(this.$refs.echarts)
          this.chartBar.clear()
        }
      }
    }
  },
  methods: {
    resize (val) {
      let nowClientWidth = document.documentElement.clientWidth
      return val * (nowClientWidth / 750)
    },
    changeFlag () {
      this.$emit('changeFlag', 3)
    },
    // 获取数据并给charts添加数据
    initChartBar () {
      let labelName = this.labelName
      let labelCount = this.labelCount
      var option = {
        grid: {
          left: '18%',
          right: '7%',
          bottom: '15%',
          top: '5%'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c}'
        },
        yAxis: {
          type: 'value',
          splitLine: false,
          axisLine: {
            show: true,
            lineStyle: {
              color: '#ccc'
            }
          },
        },
        xAxis: {
          data: labelName,
          axisLine: {
            show: true,
            lineStyle: {
              color: '#ccc'
            }
          },
          axisLabel: {
            color: '#666666',
            fontSize: this.resize(22)
          },
          
          axisLabel: {
            interval:0 
          },
          axisTick: {
            show: false
          }
        },
        series: [
          {
            showBackground: true,
            backgroundColor: '#F5F9FF',
            name: '小区接种统计',
            type: 'bar',
            data: labelCount,
            barWidth: this.resize(24),
            backgroundStyle: {
              borderRadius:[this.resize(20),this.resize(20), this.resize(20), this.resize(20)]
            },
            label: {
              show: true,
              position: 'insideTop',
              offset: [0, this.resize(2)],
              formatter (params) {
                let per =  (labelCount.reduce((a, b) => a+b) / params.value).toFixed(2)
                return `${params.value}`
              },
              fontStyle: {
                color: '#666666'
              }
            },
            itemStyle: {
              normal: {
                color: '#387FF5',
                barBorderRadius:[this.resize(20),this.resize(20), this.resize(20), this.resize(20)]
              }
            },
          }
        ]
      }
      this.chartBar = echarts.init(this.$refs.echarts)
      this.chartBar.setOption(option)
      window.addEventListener('resize', () => {
        if (this.chartBar) {
          this.chartBar.resize()
        }
      })
    }
  },
  mounted () {
    this.initChartBar()
  }
}
</script>

<style lang="scss" scoped>
div {
  height: 100%;
}
#label-type {
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 100%;
  // display: flex;
  // flex-direction: column;
  box-sizing: border-box;
  .chart-box {
    height: 100%;
    z-index: 999;
  }
}
</style>
